import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  dataReset,
  dataSetConfig, dataSetLoading,
  dataSetSearch,
} from "../redux/actions/dataAction";
import { tabAdd, tabSelectWithWarning } from "../redux/actions/tabActions";
import { ISearchUser } from "../store/types/userTypes";
import { RoutePaths } from "../utils/Items";
import {
  tabClose,
  tabSelect,
  tabShowLimit,
} from "../redux/actions/tabActions";
import { useStore } from "./useStore";

const useTabs = () => {
  const dispatch = useDispatch();
  const { tabStore, dataStore } = useStore();
  const [preSelect, setPreSelect] = useState("-1");
  const history = useHistory();

  const addTabWithStore = (
    result: ISearchUser,
    options?: { eventType?: "in" | "out"; isMultipleExit?: boolean }
  ) => {
    if (dataStore.loading) return;
    dispatch(dataSetLoading(true))
    dispatch(dataSetSearch(result));
    if (options)
      dispatch(
        dataSetConfig({
          eventType: options.eventType,
          title: options.eventType,
        })
      );
    addTab(
      result.dni || "" + result.pass || "" + result.qr || "",
      options?.isMultipleExit || false
    );
  };

  const addTab = (id: string, isMultipleExit?: boolean) => {
    if (tabStore.tabs.length < tabStore.max) {
      dispatch(
        tabAdd({
          index: 0,
          id: id,
          info: { title: id },
          isMultipleExit: isMultipleExit,
        })
      );
      history.push(RoutePaths.EntryEvent);
    } else {
      dispatch(tabShowLimit(true));
      dispatch(dataReset());
    }
  };

  const onCloseTab = (value: number) => {
    if (value.toString() === tabStore.tabSelectIndex) history.goBack();
    dispatch(tabClose(value));
  };

  const autoChangeTab = (value: string) => {
    if (value !== "-1") {
      dispatch(tabSelectWithWarning(true));
      onChangeTab(value, () => {});
    }
  };

  const onChangeTab = (value: string, onPreSelect: () => void) => {
    if (tabStore.tabSelectIndex !== value) {
      if (value === "-1") {
        setPreSelect(value);
        onPreSelect();
      } else {
        dispatch(tabSelect(value));
        if (value === "-1") history.push(RoutePaths.SearchManualInput);
        else {
          if (history.location.pathname !== RoutePaths.EntryEvent)
            history.push(RoutePaths.EntryEvent);
        }
      }
    }
  };

  const onChangeTabPreselect = () => {
    dispatch(tabSelect(preSelect));
    if (preSelect === "-1") history.push(RoutePaths.SearchManualInput);
    else {
      if (history.location.pathname !== RoutePaths.EntryEvent)
        history.push(RoutePaths.EntryEvent);
    }
  };

  const selectPrev = () => {
    const tab = tabStore.tabs.find(
      (tab) => tab.index.toString() === tabStore.tabSelectIndex
    );
    let index;
    if (tab) index = tabStore.tabs.indexOf(tab);
    if (index && index !== 0) {
      const newIndexSelect = tabStore.tabs[index - 1];
      dispatch(tabSelect(newIndexSelect.index.toString()));
    }
  };

  const selectNext = () => {
    const tab = tabStore.tabs.find(
      (tab) => tab.index.toString() === tabStore.tabSelectIndex
    );
    let index;
    if (tab) index = tabStore.tabs.indexOf(tab);
    if (index !== undefined && index < tabStore.tabs.length - 1) {
      const newIndexSelect = tabStore.tabs[index + 1];
      dispatch(tabSelect(newIndexSelect.index.toString()));
    }
  };

  return {
    addTab,
    addTabWithStore,
    onChangeTab,
    autoChangeTab,
    onChangeTabPreselect,
    onCloseTab,
    selectPrev,
    selectNext,
  };
};

export default useTabs;
